import React from "react";
// import { Control, Form } from "react-redux-form";
//5888
import { useFormik } from "formik";

import logo from "../../../assets/images/lumen-logo.svg";
// dummy logic
// const formik = useFormik({
//   initialValues: {
//     email: "",
//     password: "",
//   },
//   validate: (values) => {
//     const errors = {};
//     if (!values.email) errors.email = "Required";
//     if (!values.password) errors.password = "Required";
//     return errors;
//   },
//   onSubmit: (values) => {
//     console.log("Form submitted:", values);
//     formik.resetForm();
//   },
// });

// dummy logic
const autoFill = () => {
  formik.setFieldValue("email", "user@example.com");
  formik.setFieldValue("password", "secret123");
};

// does this need to be a class make functional comp 5888
class ForgotPassword extends React.Component {
  handleSubmit(recoverPassword) {
    console.log(recoverPassword);
  }

  render() {
    return (
      <div className="login">
        <div className="login__image-container">
          <img src={logo} alt="logo" />
        </div>
        {/* PI-5888 */}
        <form onSubmit={formik.handleSubmit}>
          <div>
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
            />
            {formik.errors.email && <div>{formik.errors.email}</div>}
          </div>
          <div>
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
            />
            {formik.errors.password && <div>{formik.errors.password}</div>}
          </div>
          <button type="submit">Login</button>
          <button type="button" onClick={autoFill}>
            Auto Fill
          </button>
        </form>
        {/* <Form
          model="forms.recoverPassword"
          onSubmit={(recoverPassword) => this.handleSubmit(recoverPassword)}
          className="my-details__form"
        >
          <h2>Forgot your password?</h2>
          <label htmlFor="recoverPassword.email">E-mail</label>
          <Control.text
            model="recoverPassword.email"
            id="recoverPassword.email"
          />

          <button className="button-primary" type="submit">
            Recover Password
          </button>
        </Form> */}
      </div>
    );
  }
}

export default ForgotPassword;
